import { useCallback, useContext } from 'react';

import { ModalsWrapperContext } from '@kanda-libs/ks-design-library';

import { FINANCE_CALCULATOR_MODAL_ID } from './constants';

export interface FinanceCalculatorLinkHook {
  onClick: () => void;
}

export default function useFinanceCalculatorLink(): FinanceCalculatorLinkHook {
  const { showModal } = useContext(ModalsWrapperContext);

  const onClick = useCallback(
    () => showModal(FINANCE_CALCULATOR_MODAL_ID),
    [showModal],
  );

  return {
    onClick,
  };
}
